export default __webpack_public_path__ + "static/media/warning--sand-drift--g1.aaccd3fd.png";